<template>
  <div class="h-fit bg-cover pt-6" :style="{ backgroundImage: `url('${store.initSite.header}')` }">
    <div class="mx-4 xl:w-[1200px] h-full xl:mx-auto">
      <div class="inline-block">
        <button
          class="btnMobile bg-white px-4 py-2 rounded-md z-40 absolute xl:hidden"
          @click="showMobile = !showMobile"
          :class="{ active: showMobile }"
        >
          <i class="fa-solid fa-bars"></i>
        </button>
        <ul
          class="nav bg-white w-screen h-screen fixed top-0 left-0 z-10 flex flex-col pt-12"
          :class="{ block: showMobile, hidden: !showMobile }"
        >
          <li class="liMain small">
            <RouterLink :to="{ path: '/', name: '' }" @click="showMobile = false">
              <p>Início</p>
            </RouterLink>
          </li>
          <li class="liMain" v-for="(categoria, i) in paginasCategorias" :key="i">
            <p>{{ categoria.cat }}&nbsp;<i class="fa-solid fa-sort-down"></i></p>
            <div class="subNav border shadow-md">
              <ul>
                <li v-for="(pagina, index) in categoria.paginas" :key="index">
                  <RouterLink :to="{ path: `/pagina/${pagina.url}` }" @click="showMobile = false">
                    <span>{{ pagina.title }}</span>
                  </RouterLink>
                </li>
              </ul>
            </div>
          </li>
          <li class="liMain small">
            <p>API&nbsp;<i class="fa-solid fa-sort-down"></i></p>
            <div class="subNav border shadow-md">
              <ul>
                <li>
                  <RouterLink
                    :to="{ path: '/api', name: 'HabbletApi' }"
                    @click="showMobile = false"
                  >
                    <span>Emblemas/Mobis</span>
                  </RouterLink>
                </li>
                <li>
                  <RouterLink
                    :to="{ path: '/pagina/imager', name: 'imager' }"
                    @click="showMobile = false"
                  >
                    <span>Habblet Imager</span>
                  </RouterLink>
                </li>
                <li>
                  <RouterLink
                    :to="{ path: '/profile-api', name: 'ProfileApi' }"
                    @click="showMobile = false"
                  >
                    <span>Perfil Habblet</span>
                  </RouterLink>
                </li>
              </ul>
            </div>
          </li>
        </ul>
        <button
          @click="store.modRd = true"
          class="ml-14 xl:ml-0 rounded-3xl shadow-inner hover:shadow-md shadow-slate-900/50 bg-slate-950/30 flex flex-row gap-3 items-center justify-between px-5 py-2"
        >
          <img :src="headphonesIcon" alt="ouvintes" />
          <span class="font-bold text-base text-white">{{ store.radio.ouvintes }}</span>
        </button>
      </div>
      <div class="inline-flex float-right gap-2 items-center">
        <a
          v-if="store.hasPanelAccess"
          href="https://painel.radiohabblet.com.br//"
          target="_blank"
          class="cursor-pointer font-poppins bg-white hover:bg-gray-100 shadow-md text-[#112535] font-bold text-sm rounded-3xl px-4 py-1 xl:py-3 flex flex-row gap-2 items-center"
        >
          <i class="fa-solid fa-gauge-high"></i>
          <span>Painel</span>
        </a>
        <button
          @click="() => (store.initUser.user ? (modU = true) : (modL = true))"
          class="cursor-pointer font-poppins bg-white hover:bg-gray-100 shadow-md text-[#112535] font-bold text-sm rounded-3xl px-4 xl:px-9 py-1 xl:py-3 flex flex-row gap-4 items-center"
        >
          <span v-if="store.logged === 'false' || !store.logged">Login</span>
          <div v-else class="flex flex-row gap-1 items-center">
            <div
              class="w-8 h-8"
              style="background-size: 75px 95px; background-position: -23px -22px"
              :style="{
                backgroundImage: `url('${avatarUrl(store.initUser.user, { action: 'std,crr=', direction: 4, headonly: true, size: 'm', img_format: '', dance: '', effect: '', frame_num: 30 })}')`,
              }"
            />
            <span>{{ store.initUser.user }} </span>
            <i id="playing" class="ml-2 fa-solid fa-caret-down"></i>
          </div>
        </button>
      </div>
      <div class="block pt-8 pb-8 xl:pb-0 xl:pl-8 -mb-10">
        <RouterLink :to="{ path: '/', name: '' }" class="inline-block w-fit h-fit">
          <img :src="store.initSite.logo" alt="logo radio habblet" class="max-w-60 max-h-60" />
        </RouterLink>
        <button v-if="camp !== ''" class="bg-[#d61dee] p-4 text-sm rounded-full float-right mt-6 font-normal animate__animated animate__pulse animate__infinite animate__slow hover:animate-none" @click="modV = true">
          <i class="fa-solid fa-ranking-star"></i>&nbsp;Enquete: <b>{{ camp }}</b>
        </button>
      </div>
      <div class="flex justify-end">
        <div class="flex flex-row gap-3 items-center">
          <img :src="volumeIcon" alt="Ouvintes" />
          <input
            type="range"
            class="w-full h-2 accent-white bg-slate-950/30 rounded-lg cursor-pointer appearance-none shadow-md bg-gradient-to-r from-white to-slate-950/30"
            :style="[
              `--tw-gradient-from-position: ${store.radio.volume}%`,
              `--tw-gradient-to-position: ${store.radio.volume}%`,
            ]"
            min="0"
            max="100"
            step="1"
            v-model="store.radio.volume"
          />
        </div>
      </div>
      <div class="mt-6 flex justify-end">
        <div
          class="w-full xl:w-fit h-11 pl-6 pr-3 text-white float-right flex flex-row gap-3 items-center bg-slate-950/30 shadow-inner shadow-slate-900/40 rounded-t-2xl"
        >
          <div
            class="relative grow flex flex-row items-center gap-1 text-sm border-solid border-r border-slate-950 pr-2"
          >
            <span class="-top-3 absolute py-0 px-2 bg-red-600 rounded-3xl font-bold text-[0.60rem]">
              AGORA
            </span>
            <div
              class="w-[45px] h-[45px] bg-no-repeat"
              style="background-size: auto; background-position: -23px -30px"
              :style="{
                backgroundImage: `url('${avatarUrl(agoraUser, { headonly: true })}')`,
              }"
            />
            <b>{{ agoraUser }}</b>
          </div>
          <div class="hidden relative xl:flex flex-row items-center gap-1 text-sm">
            <span
              class="-top-3 absolute py-0 px-2 bg-green-600 rounded-3xl font-bold text-[0.60rem]"
            >
              DEPOIS
            </span>
            <div
              class="w-[45px] h-[45px] bg-no-repeat"
              style="background-size: auto; background-position: -23px -30px"
              :style="{
                backgroundImage: `url('${avatarUrl(proximoUser, { headonly: true })}')`,
              }"
            />
            <b>{{ proximoUser }}</b>
          </div>
          <div class="flex flex-row gap-1">
            <!-- botão mensagem ao locutor oculto temporariamente -->
            <!-- <button v-if="store.logged" @click="showPed = !showPed" ...> -->

            <button
              @click="curtirLocutor()"
              class="rounded-3xl shadow-inner shadow-slate-900/50 bg-slate-950/30 flex flex-row gap-3 items-center justify-between p-2"
            >
              <i v-if="store.radio.liked == 'true'" class="fa-slid fa-heart"></i>
              <i v-else class="fa-regular fa-heart"></i>
            </button>
          </div>
        </div>
      </div>
      <div
        id="navbar"
        class="hidden h-14 xl:grid grid-flow-col justify-stretch items-center bg-white rounded-t-md"
      >
        <RouterLink
          :to="{ path: '/', name: '' }"
          class="h-full cursor-pointer font-poppins bg-white rounded-tl-md hover:bg-gray-100 text-[#112535] font-bold text-sm flex flex-row gap-4 items-center justify-center"
        >
          <span>Início</span>
        </RouterLink>
        <div
          v-for="(categoria, i) in paginasCategorias"
          :key="i"
          class="!border-l !border-l-gray-200 group relative h-full cursor-pointer font-poppins bg-white hover:bg-gray-100 text-[#112535] font-bold text-sm flex flex-row gap-4 items-center justify-center"
        >
          <span>{{ categoria.cat }}</span> <i class="fa-solid fa-caret-down"></i>
          <div
            class="w-full absolute top-14 invisible group-hover:visible h-fit z-10 bg-white overflow-hidden rounded-b-md flex flex-col justify-center items-center shadow-md"
          >
            <RouterLink
              v-for="(pagina, index) in categoria.paginas"
              :key="index"
              class="text-center py-3 hover:bg-gray-100 w-full h-full"
              :to="{ path: `/pagina/${pagina.url}` }"
              @click="showMobile = false"
            >
              <span>{{ pagina.title }}</span>
            </RouterLink>
          </div>
        </div>
        <div
          class="!border-l !border-l-gray-200 group relative h-full cursor-pointer font-poppins bg-white rounded-tr-md hover:bg-gray-100 text-[#112535] font-bold text-sm flex flex-row gap-4 items-center justify-center"
        >
          <span>API</span> <i class="fa-solid fa-caret-down"></i>
          <div
            class="w-full absolute top-14 invisible group-hover:visible h-fit z-10 bg-white overflow-hidden rounded-b-md flex flex-col justify-center items-center shadow-md"
          >
            <RouterLink
              class="text-center py-3 hover:bg-gray-100 w-full h-full"
              :to="{ path: '/api', name: 'HabbletApi' }"
              @click="showMobile = false"
            >
              <span>Emblemas/Mobis</span>
            </RouterLink>
            <RouterLink
              class="text-center py-3 hover:bg-gray-100 w-full h-full"
              :to="{ path: '/pagina/imager', name: 'imager' }"
              @click="showMobile = false"
            >
              <span>Habblet Imager</span>
            </RouterLink>
            <RouterLink
              class="text-center py-3 hover:bg-gray-100 w-full h-full"
              :to="{ path: '/profile-api', name: 'ProfileApi' }"
              @click="showMobile = false"
            >
              <span>Perfil Habblet</span>
            </RouterLink>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="xl:h-[300px]">
    <div
      class="mx-4 xl:mx-auto xl:w-[1200px] h-full rounded-b-md bg-white grid grid-cols-1 xl:grid-cols-3 overflow-hidden shadow-lg"
    >
      <div class="bg-blue-300 flex flex-col items-center justify-center">
        <PublicidadeSlide />
      </div>
      <div
        class="flex flex-col items-center justify-center"
        :style="{ backgroundColor: store.initSite.color1 }"
      >
        <EmblemasMobis />
      </div>
      <div
        class="flex flex-col items-center justify-center"
        :style="{ backgroundColor: store.initSite.color2 }"
      >
        <ValoresRecordes />
      </div>
    </div>
  </div>
  <div id="noticias" v-if="route.fullPath === '/'">
    <div class="mx-4 xl:mx-auto xl:w-[1200px] flex flex-col gap-4 mt-10">
      <div class="flex flex-col xl:flex-row gap-4 justify-between">
        <div class="flex flex-row gap-4 font-poppins">
          <div class="rounded-full bg-white p-4 shadow-sm h-fit">
            <img :src="noticiaIcon" alt="noticia" />
          </div>
          <div class="flex flex-col">
            <p class="font-bold text-xl text-[#112535]">Notícias recentes</p>
            <span class="font-light text-sm text-[#112535]/70"
              >Fique por dentro das novidades do Habblet e do mundo</span
            >
          </div>
        </div>
        <div class="actions flex flex-row ml-auto mt-2">
          <button
            :disabled="noticias.paginaAnteriorDesabilitada"
            @click="getNoticias(noticias.paginaAnterior)"
          >
            <i class="fa-solid fa-angle-left"></i>
          </button>
          <button
            :disabled="noticias.proximaPaginaDesabilitada"
            @click="getNoticias(noticias.proximaPagina)"
          >
            <i class="fa-solid fa-angle-right"></i>
          </button>
          <input
            type="text"
            name="search"
            placeholder="Pesquisar"
            v-model="procurarNoticia"
            @change="getNoticias()"
          />
          <button><i class="fa-solid fa-magnifying-glass"></i></button>
        </div>
      </div>
      <div id="publicacoes" class="grid grid-cols-1 xl:grid-cols-4 gap-4 mt-4 min-h-[270px]">
        <template v-if="loadingNoticias">
          <div v-for="i in 8" :key="i" class="bg-white shadow-sm rounded-md p-2 flex flex-col gap-2 h-full">
            <Sk w="100%" h="112px" rounded="rounded-md" />
            <Sk w="80%" h="14px" extra="mt-1" />
            <Sk w="100%" h="11px" />
            <Sk w="90%" h="11px" />
            <div class="mt-auto flex flex-row gap-2 items-center">
              <Sk w="32px" h="32px" rounded="rounded-full" />
              <Sk w="120px" h="10px" />
            </div>
          </div>
        </template>
        <template v-else>
        <RouterLink
          v-for="noticia in noticias.publicacoes" :key="noticia.id"
          class="bg-white shadow-sm hover:shadow-lg flex flex-col p-2 rounded-md overflow-hidden h-full font-poppins relative"
          :to="{ path: `noticia`, name: 'News', params: { id: noticia.id, url: noticia.url } }"
        >
            <div
              v-if="noticia.fixada"
              class="pin-badge m-1"
              :style="{ backgroundColor: store.initSite.color1 }"
              title="Notícia fixada"
            >
              <i class="fa-solid fa-thumbtack"></i>
            </div>
            <div
              class="block h-28 rounded-md bg-cover"
              :style="{ backgroundImage: `url('${noticia.imagem}')` }"
            ></div>
            <p class="mt-3 font-bold text-sm" :style="{ color: store.initSite.color1 }">
              {{ noticia.titulo }}
            </p>
            <span class="mt-2 text-xs font-light">{{ noticia.descricao }}</span>
            <div class="mt-auto text-xs flex flex-row gap-2 items-center text-[#042951]">
              <div
                class="w-8 h-8"
                :style="`background-size: 70px 95px;background-position: -16px -22px;background-image: url('${avatarUrl(noticia.autor, { action: 'std,crr=', direction: 4, headonly: true, size: 'm', img_format: '', dance: '', effect: '', frame_num: 30 })}');`"
              />
              <p>{{ noticia.autor }} • há {{ noticia.time }}</p>
              <span class="grow text-right pr-2"
                ><i class="fa-solid fa-comment"></i> {{ noticia.comments }}</span
              >
            </div>
        </RouterLink>
        </template>
      </div>
    </div>
  </div>

  <div class="path left !text-xs !max-h-8 xl:!max-h-12 xl:!text-sm"></div>

  <Transition name="slide-fade">
    <ModLogin
      v-if="modL"
      @close="modL = false"
      @register="
        () => {
          modR = true
          modL = false
        }
      "
      @forgot="
        () => {
          modF = true
          modL = false
        }
      "
    />
  </Transition>
  <Transition name="slide-fade">
    <ModRegister v-if="modR" @close="modR = false" />
  </Transition>
  <Transition name="slide-fade">
    <ModUser v-if="modU" @close="modU = false" />
  </Transition>
  <Transition name="slide-fade">
    <ModRadio v-if="store.modRd" @close="store.modRd = false" />
  </Transition>
  <Transition name="slide-fade">
    <ModForgot v-if="modF" @close="modF = false" />
  </Transition>
  <Transition name="slide-fade">
    <VotesMod v-if="modV" @close="modV = false" :titlec="camp" :id="camp_id" />
  </Transition>
  <Transition name="slide-fade">
    <ModPedido v-if="showPed" @close="showPed = !showPed" />
  </Transition>
</template>

<script setup>
import { useStore } from '@/stores/index.js'
import headphonesIcon from '@/assets/headphones.svg'
import volumeIcon from '@/assets/volume.svg'
import cartaIcon from '@/assets/carta.svg'
import noticiaIcon from '@/assets/noticia.svg'
import { computed, defineAsyncComponent, onMounted, reactive, ref, watch } from 'vue'
import { useRoute } from 'vue-router'
import PublicidadeSlide from '@/components/header/publicidade.vue'
import ValoresRecordes from '@/components/header/valoresRecordes.vue'
const EmblemasMobis = defineAsyncComponent({
  loader: () => import('@/components/header/emblemasMobis.vue'),
  ssr: false,
})
import ModLogin from '@/components/modals/login.vue'
import ModUser from '@/components/modals/logged-menu.vue'
import ModRadio from '@/components/modals/radio.vue'
import ModForgot from '@/components/modals/forgot.vue'
import ModPedido from '@/components/modals/pedidos.vue'
import he from 'he'
import ModRegister from '@/components/modals/register.vue'
import VotesMod from '@/components/modals/votes.vue'
import { getPagCat, getNews, getCampanha, likeAnnouncer, avatarUrl } from '@/services/api.js'
import { trackEvent } from '@/services/analytics.js'
import Sk from '@/components/usefulness/Sk.vue'

const route = useRoute()
const store = useStore()

const agoraUser   = computed(() => store.radio.name || store.schedule.hours[0]?.user || 'BletDJ')
const proximoUser = computed(() => store.radio.proximo || store.schedule.hours[1]?.user || 'BletDJ')
const paginasCategorias = ref([])
const loadingNoticias = ref(true)
const noticias = reactive({
  publicacoes: [],
  proximaPagina: 0,
  proximaPaginaDesabilitada: false,
  paginaAnterior: 0,
  paginaAnteriorDesabilitada: false,
})
const procurarNoticia = ref('')
const modL = ref(false)
const modR = ref(false)
const modF = ref(false)
const modU = ref(false)
const showMobile = ref(false)
const camp = ref('')
const camp_id = ref(0)
const modV = ref(false)

let showPed = ref(false)

async function getCamp() {
  const data = await getCampanha()
  if (data.length > 0) {
    camp.value = data[0].campaign
    camp_id.value = data[0].id
  }
}

async function getPaginasCategorias() {
  paginasCategorias.value = await getPagCat()
}

async function curtirLocutor() {
  if (!store.logged) {
    store.Alert('Logue-se primeiro!')
    return
  }
  const r = await likeAnnouncer()
  store.Alert(r.text)
  if (!r.error) store.radio.liked = true
}

async function getNoticias(pagina = 1) {
  loadingNoticias.value = true
  const response = await getNews({ pag: pagina, s: procurarNoticia.value, limit: 8 })
  if (procurarNoticia.value.trim() && pagina === 1) {
    trackEvent('search_news', {
      search_term_length: procurarNoticia.value.trim().length,
      results_count: (response.news ?? []).length,
    })
  }
  noticias.publicacoes = response.news ?? []
  noticias.paginaAnterior = response.prev ?? 0
  noticias.proximaPagina  = response.next ?? 0
  noticias.paginaAnteriorDesabilitada = parseInt(response.prev) === 0
  noticias.proximaPaginaDesabilitada  = response.next === 0
  loadingNoticias.value = false
}

onMounted(() => {
  getNoticias()
  getPaginasCategorias()
  getCamp()
  if (!store.radio.name) store.player()
})

watch(
  () => route.fullPath,
  (newRoute) => {
    if (newRoute === '/') getNoticias()
  },
)

watch(
  () => store.radio.volume,
  (newVolume) => {
    store.storeVolume(newVolume / 100)
  },
)

</script>

<style scoped>
#navbar .router-link-active {
  @apply bg-gray-200 border-solid border-b-4 border-green-600;
}

.pin-badge {
  position: absolute;
  top: 8px;
  left: 8px;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
  color: #fff;
  font-size: 10px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.2);
  pointer-events: none;
}

#navbar .group .router-link-active {
  @apply bg-green-600 text-white;
}

#navbar .group:has(.router-link-active) {
  @apply bg-gray-200 border-solid border-b-4 border-green-600;
}

.actions {
  user-select: none;
}

.actions button {
  width: 34px;
  height: 34px;
  background-color: #d7dde4;
  border-radius: 30px;
  font-size: 16px;
  color: #9ea6af;
  margin-left: 4px;
  cursor: pointer;
}

.actions input {
  width: 140px;
  height: 34px;
  border-radius: 23px;
  background-color: #e7ebf0;
  padding: 0 10px;
  color: #9ea6af;
  font-size: 14px;
  margin-left: 6px;
}

.actions input::placeholder {
  color: #9ea6af;
  font-size: 14px;
}

.actions form button {
  background-color: #2fc145;
  color: #fff;
}

.nav .liMain {
  position: relative;
  height: 80px;
  transition: all 0.4s ease;
  top: 0;
  left: 0;
}

.nav .liMain:hover {
  box-shadow: inset 0 -80px 0 0 rgba(13, 147, 198, 0.2);
}

/* .nav .liMain:hover {background: rgb(33,66,93);background: linear-gradient(180deg, rgba(33,66,93,0) 0%, rgba(13,147,198,.2) 100%);} */

.nav .liMain p {
  position: relative;
  width: 100%;
  text-align: center;
  line-height: 80px;
  user-select: none;
  font-size: 16px;
  color: black;
  font-weight: 600;
}

.nav .liMain:hover p {
  color: var(--color1);
}

.nav .liMain p i {
  position: relative;
  top: -3px;
}

.nav .liMain .subNav {
  position: absolute;
  left: 50%;
  top: 70px;
  width: 200px;
  height: auto;
  background-color: rgb(252, 252, 253);
  border-radius: 20px;
  padding: 6px;
  opacity: 0;
  transition: all 0.4s ease-in-out;
  visibility: hidden;
  z-index: 99;
  transform: translateX(-50%);
}

.nav .liMain:hover .subNav {
  opacity: 1;
  height: auto;
  visibility: visible;
}

.nav .liMain .subNav::after {
  content: '';
  position: absolute;
  top: -6.5px;
  left: 50%;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 0 6px 6px 6px;
  border-color: transparent transparent rgb(250, 250, 250) transparent;
  transform: translateX(-50%);
}

.nav .liMain .subNav ul li {
  width: 100%;
  height: 40px;
  border-radius: 40px;
  background-color: rgba(255, 255, 255, 1);
  margin-top: 4px;
}

.nav .liMain .subNav ul li:hover {
  background-color: rgba(255, 255, 255, 0.4);
}

.nav .liMain .subNav ul li span {
  float: left;
  width: 100%;
  height: 100%;
  font-size: 14px;
  text-align: center;
  line-height: 40px;
  padding: 0 16px;
}

/*noinspection ALL*/
.path {
  position: fixed;
  bottom: 0;
  width: auto;
  height: 60px;
  background-color: var(--color2);
  border-radius: 16px 16px 0 0;
  box-shadow: 0 -2px 6px 0 rgba(0, 0, 0, 0.2);
  color: #fff;
  font-size: 14px;
  z-index: 99;
}

.path.left {
  left: 5%;
}

.path button {
  width: auto;
  height: 100%;
  padding: 0 24px;
}

.path button.line {
  border-right: 1px solid rgba(255, 255, 255, 0.3);
}
</style>
